import $ from "jquery";
import "@accessible360/accessible-slick";

function init() {
  $(".js-vertical-carousel").each(function() {
    const autoplay =
      $(this).data("autoplay") === true || $(this).data("autoplay") === "true";
    $(this).slick({
      accessibility: true,
      arrows: true,
      centerMode: false,
      dots: true,
      infinite: true,
      lazyLoad: "progressive",
      autoplay,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }
      ],
      slidesToScroll: 1,
      slidesToShow: 3
    });
  });

  $(".js-horizontal-carousel").each(function() {
    const autoplay =
      $(this).data("autoplay") === true || $(this).data("autoplay") === "true";
    $(this).slick({
      arrows: true,
      centerMode: false,
      dots: true,
      infinite: true,
      lazyLoad: "progressive",
      slidesToScroll: 1,
      slidesToShow: 1,
      autoplay,
      autoplaySpeed: 5000
    });
  });

  $(".js-ticket-carousel").each(function() {
    const autoplay =
      $(this).data("autoplay") === true || $(this).data("autoplay") === "true";
    let numberOfSlidesToShow = 4;
    let numberOfSlidesToShow1023 = 3;
    let numberOfSlidesToShow879 = 2;
    let numberOfSlidesToShow719 = 1;

    if (
      $(this)
        .parents(".content-panel__row")
        .hasClass("content-panel__row--two-column")
    ) {
      numberOfSlidesToShow = 2;
      numberOfSlidesToShow1023 = 1;
      numberOfSlidesToShow879 = 1;
      numberOfSlidesToShow719 = 1;
    }
    $(this).slick({
      accessibility: true,
      arrows: true,
      centerMode: false,
      dots: true,
      infinite: true,
      lazyLoad: "progressive",
      autoplay,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToScroll: 1,
            slidesToShow: numberOfSlidesToShow1023
          }
        },
        {
          breakpoint: 879,
          settings: {
            centerMode: false,
            slidesToScroll: 1,
            slidesToShow: numberOfSlidesToShow879
          }
        },
        {
          breakpoint: 719,
          settings: {
            centerMode: false,
            slidesToScroll: 1,
            slidesToShow: numberOfSlidesToShow719
          }
        }
      ],
      slidesToScroll: 1,
      slidesToShow: numberOfSlidesToShow
    });
  });

  // Manually add unique IDs to carousels where Slick doesn't add them
  let carousels = 0;

  $(".slick-slider").each(function() {
    let slides = 0;

    $(this)
      .find(".slick-slide:not(.slick-cloned)")
      .each(function() {
        $(this).attr("id", "slick-slide" + carousels + slides);
        $(this)
          .find(".carousel__slide")
          .append(
            '<div class="carousel__slide-id js-carousel-id">slick-slide' +
              carousels +
              slides +
              "</div>"
          );
        slides++;
      });

    carousels++;
  });

  $(document).on("keypress", e => {
    // Show slide IDs on pressing Shift + C
    if (e.which === 67) {
      $("body").toggleClass("reveal-carousel-ids");
    }
  });

  $(".js-carousel-id").on("click", function() {
    const $temp = $("<input>");
    const id =
      window.location.href.replace(window.location.hash, "") +
      "#" +
      $(this).text();
    $("body").append($temp);
    $temp.val(id).select();
    document.execCommand("copy");
    $temp.remove();
    alert(id + " copied to clipboard");
  });
}

export default { init };
